module.exports = __webpack_public_path__ + "static/media/41-2.c36e87d8.mp3";